module.exports = __webpack_public_path__ + "static/media/geogames_highlow.eecc5823.png";